import React, { Component } from 'react';
import './index.less';
import office_btn from './img/office-more.png';
import recruit_btn from './img/recruit-more.png';
import evaluation_btn from './img/evaluation-more.png';
import backtone_btn from './img/backtone-more.png';
import exame_btn from './img/exame-more.png';
import employee_btn from './img/employee-more.png';
import recruitButler_btn from './img/recruitButler-more.png';
import tab01 from './img/tab01.png';
import tab02 from './img/tab02.png';
import tab03 from './img/tab03.png';

import tab01_icon from './img/tab01-icon.png';
import tab02_icon from './img/tab02-icon.png';
import tab03_icon from './img/tab03-icon.png';

import tab01_icon_hover from './img/tab01-icon-hover.png';
import tab02_icon_hover from './img/tab02-icon-hover.png';
import tab03_icon_hover from './img/tab03-icon-hover.png';


class Content extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            list: [
                {
                    icon: tab01_icon,
                    hover: tab01_icon_hover,
                    title: '全流程跟踪',
                    des: '候选人招聘进度'
                },
                {
                    icon: tab02_icon,
                    hover: tab02_icon_hover,
                    title: 'HR /用人经理',
                    des: ' 无缝协作'
                },
                {
                    icon: tab03_icon,
                    hover: tab03_icon_hover,
                    title: '适配企业招聘流程',
                    des: '和个性需求'
                },
            ],
            tabs: [tab01, tab02, tab03],
            active: 1
        }
    }

    onMouseEnter = (val) => {
        const me = this;
        me.setState({
            active: val
        })
    }

    onMouseLeave = () => {
        const me = this;
        me.setState({
            active: 0
        })
    }

    render() {
        const me = this;
        const { list, active, tabs } = me.state;
        return (
            <div className="content">
                <div className="content__office item">
                    <div className="content__office-more more">
                        {/* <a href="//atsmade.58.com/function/case-case/#/case-library/home" target="_blank" rel="noopener noreferrer"><img src={office_btn} alt="" /></a> */}
                    </div>
                </div>
                <div className="content__recruit item">
                    <div className="content__recruit-more more">
                        <a href="//ats.chinahr.com/weixin.html" target="_blank" rel="noopener noreferrer"><img src={recruit_btn} alt="" /></a>
                    </div>
                </div>
                <div className="content__recruitButler item">
                    <div className="content__box">
                        <div className="content__box-left">
                            <img src={tabs[active]} />
                        </div>
                        <div className="content__box-right">
                            {
                                list.map((item, index) => {
                                    return (
                                        <div
                                            className={index === active ? 'content__box-right-active' : 'content__box-right-item'}
                                            key={index}
                                            onMouseEnter={() => me.onMouseEnter(index)}
                                            onMouseLeave={me.onMouseLeave}
                                        >
                                            <img src={index === active ? item.hover : item.icon} />
                                            <div className="content__box-right-text">
                                                <p>{item.title}</p>
                                                <p>{item.des}</p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="content__recruitButler-more more">
                        <a href="//ats.chinahr.com/index.html" target="_blank" rel="noopener noreferrer"><img src={recruitButler_btn} /></a>
                    </div>
                </div>
                <div className="content__evaluation item">
                    <div className="content__evaluation-more more">
                        <a href="/pages/cn/evaluation" target="_blank" rel="noopener noreferrer"><img src={evaluation_btn} /></a>
                    </div>
                </div>
                <div className="content__backtone item">
                    <div className="content__backtone-more more">
                        <a href="/pages/cn/backtone" target="_blank" rel="noopener noreferrer"><img src={backtone_btn} /></a>
                    </div>
                </div>
                <div className="content__exame item">
                    <div className="content__exame-more more">
                        <a href="/pages/cn/exame" target="_blank" rel="noopener noreferrer"><img src={exame_btn} /></a>
                    </div>
                </div>
                <div className="content__employee item">
                    <div className="content__employee-more more">
                        <a href="//employee.chinahr.com/settle/ci/leaflet" target="_blank" rel="noreferrer"><img src={employee_btn} /></a>
                    </div>
                </div>
                <div className="content__ai item">
                    <div className="content__ai-more more">
                        <a href="//chrcampus.chinahr.com/news/ai-introduction/" target="_blank" rel="noopener noreferrer"><img src={exame_btn} /></a>
                    </div>
                </div>
                {/* <div className="content__xuanjiang item">
                    <div className="content__xuanjiang-more">
                        <div className="content__xuanjiang-right"> <a href="//campus.chinahr.com/pages/xuanjiang2021/" target="_blank">点击查看更多 》</a></div>
                        <div className="content__xuanjiang-right"> <a href="//campus.chinahr.com/pages/xuanjiang2021/" target="_blank">点击查看更多 》</a></div> */}
                {/* <a href="//campus.chinahr.com/pages/xuanjiang2021/" target="_blank"><img src={employee_btn} /></a> */}
                {/* </div>
                </div> */}
            </div >
        );
    }
}

export default Content;